import { createAsyncThunk } from "@reduxjs/toolkit"

import apiClient from "src/apiClient"
import { saveToLocalStorage } from "src/localStorage"
import userReducers from "../reducers"

const updateUserDataAndSaveTokens = (state, action) => {
  userReducers.setData(state, action)
  userReducers.setTokens(state, action)
}

// `handlesOwnErrors`: the screen that calls this renders the refusal itself, against the field it
// is about. Without it the interceptor adds axios's own "Request failed with status code 400"
// beside it — in English, about nothing the player did — so the same refusal reads twice and the
// louder half says less. The caller still gets the rejection. (Same reason `joinLobby` carries it;
// it was the only one that did.)
export const thunk = createAsyncThunk("user/registerUser", async (data, { rejectWithValue }) => {
  try {
    const response = await apiClient.post("/users/", data, { handlesOwnErrors: true })
    const tokenResponse = await apiClient.post("/token/", { username: data.username, password: data.password }, { handlesOwnErrors: true })
    saveToLocalStorage({ refreshToken: tokenResponse.data.refresh, accessToken: tokenResponse.data.access })

    return {
      id: response.data.id,
      username: response.data.username,
      email: response.data.email,
      rankingPoints: response.data.ranking_points,
      refreshToken: tokenResponse.data.refresh,
      accessToken: tokenResponse.data.access,
    }
  } catch (error) {
    return rejectWithValue(error.response?.data)
  }
})

export const onSucceed = updateUserDataAndSaveTokens

const thunkObject = { thunk, onSucceed }
export default thunkObject
